module.exports = __webpack_public_path__ + "img/a5.1d5da57d.jpg";